module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image03-415x415.60a2fe59.jpg";